/**
 * @zh 全局类型声明 - 用于减少 as any 的使用
 * @en Global type declarations - to reduce as any usage
 */
// ============================================================================
// 类型守卫辅助函数 | Type Guard Helper Functions
// ============================================================================
/**
 * @zh 获取全局小游戏平台对象
 * @en Get global mini-game platform objects
 */
export function getGlobalWithMiniGame() {
    return globalThis;
}
/**
 * @zh 获取带内存 API 的 performance 对象
 * @en Get performance object with memory API
 */
export function getPerformanceWithMemory() {
    return performance;
}
//# sourceMappingURL=GlobalTypes.js.map